import React from "react";

function DisplayHtmlContent({ htmlContent }) {
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
}

export default DisplayHtmlContent;
